export const translations = {
  // Header navigation
  nav: {
    it: {
      home: "Home",
      about: "Chi Siamo",
      services: "Servizi",
      portfolio: "Portfolio",
      contact: "Contatti",
      openMenu: "Apri menu",
      closeMenu: "Chiudi menu",
    },
    en: {
      home: "Home",
      about: "About Us",
      services: "Services",
      portfolio: "Portfolio",
      contact: "Contact",
      openMenu: "Open menu",
      closeMenu: "Close menu",
    },
  },

  // Home / Hero
  hero: {
    it: {
      title: "Pannelli ed Espositori su Misura",
      subtitle: "Servizio specializzato di taglio e stampa su pannelli in cartone e altri materiali per aziende e professionisti.",
      ctaContact: "Richiedi Preventivo o Consulenza",
      ctaConfigurator: "Configura il tuo Pannello Online",
    },
    en: {
      title: "Custom Panels & Display Stands",
      subtitle: "Specialized cutting and printing service on cardboard and other materials for businesses and professionals.",
      ctaContact: "Request a Quote or Consultation",
      ctaConfigurator: "Configure Your Panel Online",
    },
  },

  // Services section
  services: {
    it: {
      title: "I Nostri Servizi",
      subtitle: "Soluzioni complete per ogni esigenza espositiva",
      cutting: {
        title: "Taglio Professionale",
        description: "Taglio di precisione su misura per pannelli di ogni formato e materiale.",
      },
      printing: {
        title: "Stampa Digitale",
        description: "Stampa diretta ad alta risoluzione su pannelli per risultati eccezionali.",
      },
      displays: {
        title: "Espositori su Misura",
        description: "Progettazione e realizzazione di espositori personalizzati per ogni punto vendita.",
      },
      consulting: {
        title: "Consulenza Specializzata",
        description: "Supporto nella scelta di materiali e soluzioni più adatte al tuo progetto.",
      },
      contactUs: "Contattaci",
    },
    en: {
      title: "Our Services",
      subtitle: "Complete solutions for every display need",
      cutting: {
        title: "Professional Cutting",
        description: "Precision custom cutting for panels of any size and material.",
      },
      printing: {
        title: "Digital Printing",
        description: "High-resolution direct printing on panels for exceptional results.",
      },
      displays: {
        title: "Custom Display Stands",
        description: "Design and creation of customized display stands for every retail space.",
      },
      consulting: {
        title: "Specialized Consulting",
        description: "Support in choosing the most suitable materials and solutions for your project.",
      },
      contactUs: "Contact Us",
    },
  },

  // About page
  about: {
    it: {
      title: "Chi siamo",
      subtitle: "Servizio specializzato di taglio e stampa su pannelli in cartone e altri materiali per aziende e professionisti.",
      description1: "nasce per offrire soluzioni personalizzate a realtà produttive che cercano un partner affidabile, flessibile e orientato alla qualità.",
      description2: "Siamo un team con forte esperienza nella lavorazione dei materiali e nella gestione di commesse B2B. Il nostro obiettivo:",
      objective: "trasformare un pannello grezzo in un prodotto finito, funzionale e pronto all'uso",
      knowhowTitle: "Know-how industriale",
      knowhowDescription: "Un progetto di",
      knowhowCompany: "Regalpack Srl",
      knowhowSuffix: ", azienda attiva nel packaging in cartone con specializzazione nel comparto enogastronomico.",
      approachTitle: "Il nostro approccio",
      approachSubtitle: "Tre principi che guidano il nostro lavoro",
      competence: "Competenza tecnica",
      competenceDesc: "Soluzioni concrete e realizzabili",
      reliability: "Affidabilità",
      reliabilityDesc: "Rispetto di tempi e impegni",
      flexibility: "Flessibilità",
      flexibilityDesc: "Adattamento ad ogni progetto",
    },
    en: {
      title: "About Us",
      subtitle: "Specialized cutting and printing service on cardboard panels and other materials for businesses and professionals.",
      description1: "was created to offer customized solutions to manufacturing companies looking for a reliable, flexible, and quality-oriented partner.",
      description2: "We are a team with strong experience in material processing and B2B order management. Our goal:",
      objective: "transforming a raw panel into a finished, functional product ready for use",
      knowhowTitle: "Industrial know-how",
      knowhowDescription: "A project by",
      knowhowCompany: "Regalpack Srl",
      knowhowSuffix: ", a company active in cardboard packaging with specialization in the food and wine sector.",
      approachTitle: "Our Approach",
      approachSubtitle: "Three principles that guide our work",
      competence: "Technical Expertise",
      competenceDesc: "Concrete and achievable solutions",
      reliability: "Reliability",
      reliabilityDesc: "Respect for timelines and commitments",
      flexibility: "Flexibility",
      flexibilityDesc: "Adaptation to every project",
    },
  },

  // Portfolio
  portfolio: {
    it: {
      title: "I Nostri Progetti",
      subtitle: "Una selezione dei nostri lavori più significativi",
      projects: {
        decorativo: { title: "Pannello Decorativo", description: "Pannello decorativo personalizzato per ambienti commerciali" },
        espositore: { title: "Espositore da Banco", description: "Espositore compatto per prodotti al dettaglio" },
        espositori: { title: "Espositori Multipli", description: "Serie di espositori coordinati per fiere e eventi" },
        pvc: { title: "Pannello in PVC", description: "Pannello rigido in PVC per uso esterno" },
        sagomato: { title: "Sagomato Pubblicitario", description: "Figura sagomata per campagne promozionali" },
        segnaletica: { title: "Segnaletica", description: "Cartellonistica direzionale per spazi commerciali" },
        totem: { title: "Totem Espositivo", description: "Totem autoportante per comunicazione visiva" },
      },
    },
    en: {
      title: "Our Projects",
      subtitle: "A selection of our most significant work",
      projects: {
        decorativo: { title: "Decorative Panel", description: "Custom decorative panel for commercial spaces" },
        espositore: { title: "Counter Display", description: "Compact display stand for retail products" },
        espositori: { title: "Multiple Displays", description: "Coordinated display series for trade shows and events" },
        pvc: { title: "PVC Panel", description: "Rigid PVC panel for outdoor use" },
        sagomato: { title: "Advertising Cutout", description: "Shaped cutout for promotional campaigns" },
        segnaletica: { title: "Signage", description: "Directional signage for commercial spaces" },
        totem: { title: "Display Totem", description: "Self-standing totem for visual communication" },
      },
    },
  },

  // Contact page
  contact: {
    it: {
      title: "Contattaci",
      subtitle: "Siamo a tua disposizione per qualsiasi informazione o richiesta di preventivo.",
      form: {
        name: "Nome e Cognome",
        namePlaceholder: "Il tuo nome",
        email: "Email",
        emailPlaceholder: "La tua email",
        phone: "Telefono",
        phonePlaceholder: "Il tuo numero di telefono",
        message: "Messaggio",
        messagePlaceholder: "Scrivi il tuo messaggio...",
        privacy: "Ho letto e accetto la",
        privacyLink: "Privacy Policy",
        submit: "Invia Messaggio",
        sending: "Invio in corso...",
      },
      info: {
        emailTitle: "Email",
        phoneTitle: "Telefono",
        addressTitle: "Indirizzo",
      },
      success: "Messaggio inviato con successo!",
      error: "Si è verificato un errore. Riprova più tardi.",
    },
    en: {
      title: "Contact Us",
      subtitle: "We are at your disposal for any information or quote request.",
      form: {
        name: "Full Name",
        namePlaceholder: "Your name",
        email: "Email",
        emailPlaceholder: "Your email",
        phone: "Phone",
        phonePlaceholder: "Your phone number",
        message: "Message",
        messagePlaceholder: "Write your message...",
        privacy: "I have read and accept the",
        privacyLink: "Privacy Policy",
        submit: "Send Message",
        sending: "Sending...",
      },
      info: {
        emailTitle: "Email",
        phoneTitle: "Phone",
        addressTitle: "Address",
      },
      success: "Message sent successfully!",
      error: "An error occurred. Please try again later.",
    },
  },

  // Quote/Preventivo page
  quote: {
    it: {
      title: "Richiedi un Preventivo",
      subtitle: "Configura il tuo pannello e ricevi un preventivo personalizzato.",
      step1: "I tuoi dati",
      step2: "Configura il pannello",
      next: "Avanti",
      back: "Indietro",
      submit: "Invia Richiesta",
      sending: "Invio in corso...",
    },
    en: {
      title: "Request a Quote",
      subtitle: "Configure your panel and receive a personalized quote.",
      step1: "Your details",
      step2: "Configure the panel",
      next: "Next",
      back: "Back",
      submit: "Submit Request",
      sending: "Sending...",
    },
  },

  // Footer
  footer: {
    it: {
      description: "Servizio specializzato di taglio e stampa su pannelli per aziende e professionisti.",
      contact: "Contatti",
      rights: "Tutti i diritti riservati.",
      project: "Un progetto di",
      privacy: "Privacy Policy",
      cookie: "Cookie Policy",
    },
    en: {
      description: "Specialized cutting and printing service on panels for businesses and professionals.",
      contact: "Contact",
      rights: "All rights reserved.",
      project: "A project by",
      privacy: "Privacy Policy",
      cookie: "Cookie Policy",
    },
  },

  // Testimonials
  testimonials: {
    it: {
      title: "Cosa dicono i nostri clienti",
      subtitle: "Feedback dai nostri partner e collaboratori",
    },
    en: {
      title: "What Our Clients Say",
      subtitle: "Feedback from our partners and collaborators",
    },
  },
} as const;

export type TranslationKeys = typeof translations;
